import { render } from "./TemplateFifteen.vue?vue&type=template&id=62f7f318"
import script from "./TemplateFifteen.vue?vue&type=script&lang=js"
export * from "./TemplateFifteen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__